import { OrderByType } from '../dtos';
import { IFormFieldValidationConfig, createValidatorConfig, isNotBlank } from '../Components/CoreLib/library';

/**
 * OrderByType.Equipment is 0, so `orderBy ?? OrderByType.Equipment` normalizes an unset value to Equipment
 * without a truthiness check silently lumping Equipment in with "not set" and never reaching the Quantity
 * case at all.
 */
export function normalizeOrderBy(orderBy: OrderByType | undefined): OrderByType {
    return orderBy ?? OrderByType.Equipment;
}

/**
 * Sets the Equipment-Required-or-Load/Quantity-Required validation shared by the order form and the order
 * review form line-item validation configs. Loads always requires the field; Quantity requires it only when
 * `requireQuantityRequirement` says the row is actually modifiable/actively worked on right now - the one
 * place the two forms' rules diverge.
 */
export function setOrderByRequirementValidation<T extends { orderBy?: OrderByType }>(
    validationConfig: Map<keyof T, IFormFieldValidationConfig>,
    lineItem: T,
    requireQuantityRequirement: boolean
): void {
    const orderBy = normalizeOrderBy(lineItem.orderBy);
    if (orderBy === OrderByType.Equipment) {
        validationConfig.set('equipmentRequired' as keyof T, createValidatorConfig([isNotBlank], 'Equipment Required'));
    } else if (orderBy === OrderByType.Loads || requireQuantityRequirement) {
        validationConfig.set('loadOrQuantityReq' as keyof T, createValidatorConfig([isNotBlank], 'Load/Quantity Req'));
    }
}
